const recordingcsvcolumndata = [
  { id: "recording_name", title: "Name", default: true },
  { id: "recording_filename", title: "Filename", default: true },
  { id: "recording_description", title: "Description" },
  { id: "player", title: "Preview", default: true },
];
export default recordingcsvcolumndata;
